import configData from "../configs/config.json";

const { REACT_APP_API_URL,REACT_APP_API_URL_LOCAL,REACT_APP_API_URL_DEV } = configData;
let URL = REACT_APP_API_URL;
if(window.location.hostname == 'localhost') {
    URL = REACT_APP_API_URL_LOCAL;
}
if(window.location.hostname == 'devbcrm.bhsgroup.vn') {
    URL = REACT_APP_API_URL_DEV;
}
console.log(window.location.hostname);

export const URL_LIST_ALL = URL ;